export enum SeoOpenGraphType {
  Article = 'article',
  Book = 'book',
  Business = 'business',
  Profile = 'profile',
  Website = 'website',
}
